const collateral = [
  {
    id: 0,
    name: 'Sí'
  },
  {
    id: 1,
    name: 'No'
  }
];

const traction = [
  {
    id: 0,
    name: '4x2'
  },
  {
    id: 1,
    name: '4x4'
  },
  {
    id: 2,
    name: '3X1'
  },
  {
    id: 3,
    name: '3X2'
  },
  {
    id: 4,
    name: '2X1'
  },
  {
    id: 5,
    name: '6X4'
  },
  {
    id: 6,
    name: '8X4'
  },
  {
    id: 7,
    name: '6X2'
  },
  {
    id: 8,
    name: '6X6'
  }
];

const fuel_type = [
  {
    id: 0,
    name: 'Gasolina'
  },
  {
    id: 1,
    name: 'Diesel'
  },
  {
    id: 2,
    name: 'Híbrido'
  },
  {
    id: 3,
    name: 'Eléctrico'
  }
];


const vehicle = {
  collateral,
  traction,
  fuel_type
};

export default vehicle;
